class ThreadOverview
    constructor: (el) ->
        @.$el = el
        
        @.$answerButtons = @.$el.querySelectorAll '.post-entry__answer'
        @.$sortSelect = @.$el.querySelector '.thread-overview__sort'
        @.$sortSelectInput = @.$sortSelect?.querySelector('select') ? false
        @.$postElements = @.$el.querySelectorAll '.post-entry'
        @.$postsEl = @.$el.querySelector '.thread-overview__posts'
        @.$quoteButtons = @.$el.querySelectorAll '.post-entry__quote'

        @.$el.classList.add 'thread-overview--bound'

        @.answerOverlayId = @.$el.dataset?.answerOverlayId ? false
        @.deleteOverlayId = @.$el.dataset?.deleteOverlayId ? false
        @.editOverlayId = @.$el.dataset?.editOverlayId ? false
        @.reportOverlayId = @.$el.dataset?.reportOverlayId ? false
        @.threadId = @.$el.dataset?.threadId ? undefined
        @.writeAllowed = @.$el.dataset?.wa == 'true'

        @.InitEvents()
        @.CheckForOffsetParam()
        return
    
    AnswerQuoteOverlayAction: (quoteText, quotedUser) ->
        if @.answerOverlayId
            answerOverlayEl = document.getElementById @.answerOverlayId
            if answerOverlayEl
                answerOverlayEl.dispatchEvent new CustomEvent 'overlay-show', { bubbles: false }
                openAnswerOverlayEl = document.getElementById "overlay-id_#{ @.answerOverlayId }"
                if openAnswerOverlayEl
                    addEntryPostEl = openAnswerOverlayEl.querySelector '.add-entry--post'
                    if addEntryPostEl && typeof @.threadId != 'undefined'
                        addEntryPostEl.dispatchEvent new CustomEvent 'add-entry-set-topic-id', {
                            bubbles: false
                            detail: {
                                topicId: @.threadId
                            }
                        }
                        if quoteText && quoteText != ""
                            addEntryPostEl.dispatchEvent new CustomEvent 'add-entry-receive-quote', {
                                bubbles: false
                                detail: {
                                    quotedUser: quotedUser
                                    quoteText: quoteText
                                }
                            }

        return
    
    BindAnswerAndQuoteButtons: ->
        self = @
        if @.writeAllowed
            @.$answerButtons.forEach (answerButton) ->
                if !answerButton.classList.contains 'post-entry__answer--to-bound'
                    answerButton.classList.add 'post-entry__answer--to-bound'
                    answerButton.addEventListener 'click', (e) ->
                        self.AnswerQuoteOverlayAction()
                        return
                return
            @.$quoteButtons.forEach (quoteButton) ->
                if !quoteButton.classList.contains 'post-entry__quote--to-bound'
                    quoteButton.classList.add 'post-entry__quote--to-bound'
                    quoteButton.addEventListener 'click', (e) ->
                        quoteText = if @.closest('.post-entry__content').querySelector('.post-entry__text .typo3-forum__unformatted-text') then @.closest('.post-entry__content').querySelector('.post-entry__text .typo3-forum__unformatted-text').innerHTML else @.closest('.post-entry__content').querySelector('.post-entry__text').innerHTML
                        # remove already quoted text in quoteText
                        quoteText = quoteText.replace /\[quote=(.*?)\](.*?)\[\/quote\]/gm, ""
                        quotedUser = if @.closest('.post-entry').querySelector('.user-info__name') then @.closest('.post-entry').querySelector('.user-info__name').textContent else false
                        self.AnswerQuoteOverlayAction quoteText, quotedUser
                        return
                return
        return
    
    BindPostMenuActions: ->
        self = @
        if @.writeAllowed
            @.$postElements.forEach (postEl) ->
                if !postEl.classList.contains 'post-entry--to-bound'
                    postEl.classList.add 'post-entry--to-bound'
                    postEl.addEventListener 'post-entry-delete-click', (e) ->
                        postId = e.detail?.postId ? false
                        if postId
                            self.DeleteOverlayAction postId
                        return
                    postEl.addEventListener 'post-entry-report-click', (e) ->
                        postId = e.detail?.postId ? false
                        if postId
                            self.ReportOverlayAction postId
                        return
                    postEl.addEventListener 'post-entry-edit-click', (e) ->
                        postId = e.detail?.postId ? false
                        if postId
                            self.EditOverlayAction postId
                        return
                return
        return
    
    CheckForOffsetParam: ->
        offsetParam = window.appUtils.FindGetParameter 'offset'
        pageParam = window.appUtils.FindGetParameter 'seite'
        if offsetParam || pageParam
            bodyRect = document.body.getBoundingClientRect()
            postsElRect = @.$postsEl.getBoundingClientRect()
            window.scrollTo {
                behavior: 'smooth',
                left: 0,
                top: postsElRect.top - bodyRect.top
            }
    
    DeleteOverlayAction: (postId) ->
        if postId && @.deleteOverlayId
            postEl = @.$el.querySelector ".post-entry[data-post-id=\"#{postId}\"]"
            deleteOverlayEl = document.getElementById @.deleteOverlayId
            if postEl && deleteOverlayEl
                deleteOverlayEl.dispatchEvent new CustomEvent 'overlay-show', { bubbles: false }
                openDeleteOverlayEl = document.getElementById "overlay-id_#{ @.deleteOverlayId }"
                if openDeleteOverlayEl
                    deleteEntryEl = openDeleteOverlayEl.querySelector '.delete-entry'
                    if deleteEntryEl
                        formattedTextEl = postEl.querySelector '.typo3-forum__unformatted-text'
                        previewText = if formattedTextEl then formattedTextEl.innerHTML else postEl.querySelector('.post-entry__text').innerHTML
                        deleteEntryEl.dispatchEvent new CustomEvent 'delete-entry-preview', {
                            bubbles: false,
                            detail: {
                                postId: postId
                                preview: previewText
                            }
                        }
        return
    
    EditOverlayAction: (postId) ->
        if postId && @.answerOverlayId
            postEl = @.$el.querySelector ".post-entry[data-post-id=\"#{postId}\"]"
            editOverlayEl = document.getElementById @.editOverlayId
            if postEl && editOverlayEl
                editOverlayEl.dispatchEvent new CustomEvent 'overlay-show', { bubbles: false }
                openEditOverlayEl = document.getElementById "overlay-id_#{ @.editOverlayId }"
                if openEditOverlayEl
                    addEntryEl = openEditOverlayEl.querySelector '.add-entry'
                    if addEntryEl
                        formattedTextEl = postEl.querySelector '.typo3-forum__unformatted-text'
                        editText = if formattedTextEl then formattedTextEl.innerHTML else postEl.querySelector('.post-entry__text').innerHTML
                        addEntryEl.dispatchEvent new CustomEvent 'add-entry-set-text-input', {
                            bubbles: false,
                            detail: {
                                postId: postId
                                text: editText.trim()
                            }
                        }
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'thread-overview-posts-update', (e) ->
            self.$answerButtons = self.$el.querySelectorAll '.post-entry__answer'
            self.$postElements = self.$el.querySelectorAll '.post-entry'
            self.$quoteButtons = self.$el.querySelectorAll '.post-entry__quote'
            self.BindAnswerAndQuoteButtons()
            self.BindPostMenuActions()
            return
        @.BindAnswerAndQuoteButtons()
        @.BindPostMenuActions()
        if @.$sortSelectInput
            @.$sortSelectInput.addEventListener 'change', (e) ->
                window.location = window.location.href.split("?")[0] + "?sort=" + @.value
                return
        return
    
    ReportOverlayAction: (postId) ->
        if postId && @.reportOverlayId
            postEl = @.$el.querySelector ".post-entry[data-post-id=\"#{postId}\"]"
            reportOverlayEl = document.getElementById @.reportOverlayId
            if postEl && reportOverlayEl
                reportOverlayEl.dispatchEvent new CustomEvent 'overlay-show', { bubbles: false }
                openReportOverlayEl = document.getElementById "overlay-id_#{ @.reportOverlayId }"
                if openReportOverlayEl
                    reportEntryEl = openReportOverlayEl.querySelector '.report-entry'
                    if reportEntryEl
                        formattedTextEl = postEl.querySelector '.typo3-forum__unformatted-text'
                        post = if formattedTextEl then formattedTextEl.innerHTML else postEl.querySelector('.post-entry__text').innerHTML
                        userId = postEl.dataset?.ownerId ? false
                        userName = 'Unbekannter Nutzer'
                        userPic = null
                        userInfoEl = postEl.querySelector '.user-info'
                        if userInfoEl
                            userName = userInfoEl.querySelector '.user-info__name'
                                .textContent
                            userPic = if userInfoEl.querySelector('.profile-pic__pic img') then userInfoEl.querySelector('.profile-pic__pic img').src else null
                        reportEntryEl.dispatchEvent new CustomEvent 'report-entry-set', {
                            bubbles: false,
                            detail: {
                                post: post
                                postId: postId
                                user: {
                                    id: userId
                                    name: userName
                                    pic: userPic
                                }
                            }
                        }

BindThreadOverviews = ->
    document.querySelectorAll '.thread-overview:not(.thread-overview--bound)'
        .forEach (el) ->
            new ThreadOverview el
            return

window.addEventListener 'bind-components', BindThreadOverviews